import { ViewKey } from "../../../v2/components/ViewKey.jsx";
import { T } from "../../../app/tokens.js";
import { PURPOSE_KEY } from "./travelModel.js";
import { holidayStripe } from "./travelStyles.js";

export function TravelKey({ coverage, countries }) {
  return <ViewKey testId="travel-key" title="Travel Key" groups={[
    { label: "Trip types", items: PURPOSE_KEY.map(k => ({ label: k.label, swatch: { kind: "cell", color: k.bg, border: k.border } })) },
    { label: "Calendar evidence", items: [
      { label: "Destination-country non-working day", description: "Exact names and inclusive date ranges from Admin › Non-working days; country tag identifies the destination.", swatch: { kind: "cell", color: holidayStripe, border: T.travelHolidayBorder } },
      { label: "Ripple-wide non-working day", description: "Striped bars apply across destinations.", swatch: { kind: "cell", color: holidayStripe, border: T.travelHolidayBorder } },
      { label: "Milestone trip with no travelers", description: "Dashed trip border. A milestone gap can also exist without any trip; open its project or milestone from the gap tile.", swatch: { kind: "box", color: T.travelGapBorder, borderStyle: "dashed" } },
    ] },
  ]} footer={<>
    {countries && <p>Holidays shown: {["Ripple-wide", ...[...new Set(countries)].sort()].join(", ")}</p>}
    <p>Holidays appear for every country with an upcoming or current trip, in every month, even outside the trip dates.</p>
    <p>Totals at the top count this month's trips, people and projects. Filters change what the calendar shows, not the totals.</p>
    <p>Milestone gaps look 14 days ahead.</p>
  </>} />;
}
